{
    "zendesk.login.error.failed": "Login failed",
    "zendesk.login.error.fingerprintNotReady": "Device fingerprint not ready yet. Retry in a second.",
    "zendesk.login.error.forbidden": "Access forbidden for non-Ops users.",
    "zendesk.login.error.resendFailed": "Could not resend device code",
    "zendesk.login.field.deviceCode": "Device confirmation code",
    "zendesk.login.field.email": "Email",
    "zendesk.login.field.otp": "OTP token",
    "zendesk.login.field.password": "Password",
    "zendesk.login.qrCodeHint": "Scan with Google Authenticator, then enter the OTP.",
    "zendesk.login.resendDeviceCode": "Resend device code",
    "zendesk.login.submit": "Login",
    "zendesk.login.title": "Sharelock Ops login",
    "zendesk.sidebar.claims.empty": "No claims",
    "zendesk.sidebar.claims.openedAt": "Opened {date}",
    "zendesk.sidebar.error.loadFailed": "Failed to load context",
    "zendesk.sidebar.error.noRequester": "No ticket requester email or phone available.",
    "zendesk.sidebar.error.requesterUnavailable": "Could not load the ticket requester.",
    "zendesk.sidebar.error.userNotFound": "No Sharelock user for {identity}",
    "zendesk.sidebar.logout": "Logout",
    "zendesk.sidebar.policies.empty": "No policies",
    "zendesk.sidebar.quotes.empty": "No open quotes",
    "zendesk.sidebar.refresh": "Refresh",
    "zendesk.sidebar.requester": "Requester: {requester}",
    "zendesk.sidebar.section.claims": "Claims",
    "zendesk.sidebar.section.policies": "Policies",
    "zendesk.sidebar.section.quotes": "Quotes",
    "zendesk.sidebar.section.user": "User",
    "zendesk.sidebar.user.createdAt": "Created {date}",
    "zendesk.sidebar.user.lastDevice": "Last device activity",
    "zendesk.sidebar.user.noDevice": "No device found",
    "zendesk.sidebar.error.notFound": "No Sharelock user or company for {identity}",
    "zendesk.sidebar.group.noPolicies": "No B2B policies",
    "zendesk.sidebar.group.partner": "Partner",
    "zendesk.sidebar.section.groups": "Companies"
}
